// extracted by mini-css-extract-plugin
module.exports = {"slider-field":"slider-field__rWSuy"};